import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let GateResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("gates");
  }
  getByFeatureIdAsync(workspaceId, featureId) {
    return this._get(
      buildOdataQuery(
        {
          filter: `ExperimentOperationSet/Feature/Id eq ${featureId}`
        },
        {
          baseUrl: this.getResourceUrl(workspaceId),
          additionalQueryParams: this.getDefaultQueryParams()
        }
      )
    );
  }
};
GateResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], GateResource);
const GateResourceInstance = new GateResource();
export {
  GateResource,
  GateResourceInstance as default
};
//# sourceMappingURL=Gate.resource.js.map
